import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import {
  Modal
} from 'react-bootstrap';

import PaymentForm from './PaymentForm';

import { closeReservationModal } from '../../../../actions/Reservation/payoutModal';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../../locale/jsonMessages';
import s from './ModalForm.css';

class ModalForm extends Component {
  static propTypes = {
    closeReservationModal: PropTypes.any.isRequired,
    reservationModal: PropTypes.bool
  };

  static defaultProps = {
    reservationModal: false
  };

  render() {
    const { closeReservationModal, reservationModal } = this.props;
    return (
      <Modal show={reservationModal} onHide={closeReservationModal} dialogClassName='commonModalContainer globalModalContainer' >
        <Modal.Header closeButton className='commonModalHeader'>
          <Modal.Title className='commonModalTitle'><FormattedMessage  {...messages.payoutRefund} /></Modal.Title>
        </Modal.Header>
        <Modal.Body bsClass='commonModalBody'>
          <PaymentForm />
        </Modal.Body>
      </Modal>
    );
  }
}

const mapState = (state) => ({
  reservationModal: state.reservation.reservationModal,
});

const mapDispatch = {
  closeReservationModal,
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(ModalForm)));